module.exports = __webpack_public_path__ + "static/media/instructor-8.78f4a2b9.png";